export default __webpack_public_path__ + "static/media/BetStrideBorder.f0291bb5.svg";